import { GovIcon } from '@gov-design-system-ce/react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { PageCode } from '@gov-nx/module/page';
import type { WebDataBoxRequiredBannerProps } from '@gov-nx/ui/types';

export const DataBoxRequiredBanner = ({
	requiredTypes,
	showIncompatibleMessage,
	showMissingDataBoxMessage,
}: WebDataBoxRequiredBannerProps) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const t = getLocalizeCurried(PageCode['datove-schranky']);

	const isPO = requiredTypes.some((type) => type?.startsWith('PO') ?? false);
	const isPFO = requiredTypes.some((type) => type?.startsWith('PFO') ?? false);

	const incompatibleKeyMessage = (() => {
		if (isPO && isPFO) return t('banner-service.nekompatibilni.potreba-po-pfo');
		if (isPO) return t('banner-service.nekompatibilni.potreba-po');
		if (isPFO) return t('banner-service.nekompatibilni.potreba-pfo');
		return null;
	})();

	const missingDataBoxKeyMessage = (() => {
		if (isPO && isPFO) return t('banner-service.bez-schranky.potreba-po-pfo');
		if (isPO) return t('banner-service.bez-schranky.potreba-po');
		if (isPFO) return t('banner-service.bez-schranky.potreba-pfo');
		return null;
	})();

	return (
		<div
			role="status"
			className="p-(--templates-margin-m) bg-(--background-block-primary) rounded-3xl">
			<div className="flex flex-col gap-(--spacing-m-nudge) items-start p-(--spacing-m) [ md:flex-row ]">
				<div className="flex justify-center items-center w-16 h-16 bg-(--background-primary) rounded-full text-(--color-secondary-600)">
					<GovIcon
						type="templates"
						name="datovka-fill"
						size="3xl"
					/>
				</div>
				<div className="flex flex-col gap-(--spacing-m) flex-1">
					{showIncompatibleMessage ? (
						<>
							<p className="text-headline-xs!">
								{t('banner-service.nekompatibilni.nadpis')}
							</p>
							<p>{incompatibleKeyMessage}</p>
						</>
					) : showMissingDataBoxMessage ? (
						<>
							<p className="text-headline-xs!">
								{t('banner-service.bez-schranky.nadpis')}
							</p>
							<p>{missingDataBoxKeyMessage}</p>
						</>
					) : (
						<>
							<p className="text-headline-xs!">
								{t('banner-service.zakaz.nadpis')}
							</p>
							<p>{t('banner-service.zakaz.popis')}</p>
						</>
					)}
				</div>
			</div>
		</div>
	);
};
